<!-- Beneficary card for desktop -->
<div class="bene-card-wrapper" [ngClass]="{'compact-ui': vars?.fundraiser?.is_multi_patient_campaign}" *ngIf="!isMobile && beneficiary payment-card-change">
  <div class="card-wrapper">
    <div class="flex-div align-items-center">
      <ng-template [ngTemplateOutlet]="profilePic"></ng-template>
      <div class="details">
        <div class="heading">{{'Stories.donations.beneficiary' | translatePipe | async}}
          <a *ngIf="contact && !vars.thirdPartyApp" class="contact" (click)="openDialog()"><i class="material-icons">mail_outline</i><span>{{'Stories.donations.contact' | translatePipe | async}}</span></a>
        </div>
        <div class="bene-name">{{vars?.fundraiser?.is_multi_patient_campaign && vars?.pageName?.match('stories|mini_story') && vwo.multi_patient_note_AB() && vars.donateMultiPatient?'*':''}}{{beneficiary?.full_name}}</div>
        <div class="contact-div" *ngIf="!fundraiser?.non_medical && fundraiser?.hospital?.info_1">
          <div class="circle"><i class="icon-red-cross"></i></div>
          <span class="place" [ngClass]="{'maxWidth': !contact}" *ngIf="fundraiser?.hospital?.info_1">
            <span [title]="fundraiser?.hospital?.info_1">{{fundraiser?.hospital?.info_1}}</span>
          </span>
        </div>
      </div>
    </div>
    <div *ngIf="contact && type==='v1'" class="assured-btn">
      <app-ketto-assured></app-ketto-assured>
    </div>
  </div>

  <div *ngIf="vars?.fundraiser?.is_multi_patient_campaign" class="multi-patient-dropdown">
    <app-component-loader [load]="true" selector="app-multi-patient-dropdown" />
  </div>

  <button *ngIf="!fundraiser?.non_medical && !vars.showKCart" id="verified" class="verified" type="button" (click)="popovershow()" mat-stroked-button>
    <div class="content">
      <i class="icon-verified-tick"></i>
      <span class="txt">{{'Stories.donations.verifiedByKetto' | translatePipe | async}}</span>
    </div>
  </button>
</div>

<!-- Beneficary Card for mobile -->
<div class="bene-card-wrapper bene-mobile-card" *ngIf="isMobile" [ngStyle]="{'padding': beneficiary ? '10px 10px 0' : '0 10px'}">
  <div class="flex-div2" *ngIf="beneficiary">
    <div class="bene-items">
      <ng-template [ngTemplateOutlet]="profilePic"></ng-template>
      <div class="bene-details">
        <div class="bene-title">{{'Stories.donations.beneficiary' | translatePipe | async}}</div>
        <div class="bene-name">
          {{beneficiary?.full_name}}
          <span *ngIf="contact" class="divider">|</span>
          <a *ngIf="contact && !vars.thirdPartyApp" class="contact" (click)="openDialog()"><i class="material-icons bene-contact">mail_outline</i><span>{{'Stories.donations.contact' | translatePipe | async}}</span></a>
        </div>
      </div>
    </div>
    <div *ngIf="vars.showKCart && fundraiser?.product_banner_description" class="extra-product-desc" [innerHTML]="fundraiser?.product_banner_description"></div>
    <div class="bene-items" *ngIf="!vars.showKCart && !fundraiser?.non_medical && fundraiser?.hospital?.info_1">
      <div class="circle"><i class="icon-red-cross"></i></div>
      <div class="bene-details"><div class="hospital">{{fundraiser?.hospital?.info_1}}</div></div>
    </div>
    <div *ngIf="!vars.showKCart && fundraiser?.msw_date?.info_1" class="bene-items">
      <button *ngIf="!fundraiser?.non_medical" class="verified" type="submit" (click)="openBottomSheet(varifiedTeam)" mat-stroked-button>
        <div class="content">
          <i class="icon-verified-tick"></i>
          <span class="txt">{{'Stories.donations.verifiedByKetto' | translatePipe | async}}</span>
        </div>
      </button>
    </div>
    <app-order-reco-card *ngIf="fundraiser && userData?.lastorder && vwo.quickDonate_fallback_p1_AB() === 'v2' && (userData?.lastorder?.iso_currency === currency)" [config]="{ order: userData.lastorder, userData: userData, origin: 's', type: 'v3', header_type: 'v2', showSlabs: false, showTip: false, fundraiser: fundraiser, slabTheme: 'slab-theme-v5', paymentBtnClass: 'payment-btn-theme-v3', themeColor: '#01bfbd', donatingAs: true, donateBtnLabel: 'Repeat Contribution', optionsCheck: false, onpage: true, theme: 'v2' }"></app-order-reco-card>
  </div>
  <div *ngIf="!fundraiser?.settings?.nodonorlist && fundraiser?.parent_cause_id === 149 && (!isFundraiserEnded || donationCard?.length)" class="supporters">
    <app-supporters [fundraiser]="fundraiser" [myDonations]="donationCard" />
  </div>
  <app-view-supporters *ngIf="fundraiser?.raised?.beforeTickrBackers>10 && !isDonated && !isFundraiserEnded && fundraiser?.parent_cause_id !== 149 && (!vars.showKCart)" [fundraiser]="fundraiser"
      [customTag]="fundraiser.custom_tag" [origin]="'stories'" [settings]="fundraiser?.settings" [isFundraiserEnded]="isFundraiserEnded"
      [donationCard]="donationCard" [isDonated]="isDonated" [tickrIsShown]="tickrIsShown">
  </app-view-supporters>
  <div *ngIf="donationCard && donationCard.length && fundraiser?.parent_cause_id !== 149" class="mt-2">
    <app-support-card class="donor-card" [donations]="donationCard" cardType="donor" [fundraiser]="fundraiser"></app-support-card>
  </div>
  <div *ngIf="sharyCard && sharyCard.length && fundraiser?.parent_cause_id !== 149">
    <app-support-card class="donor-card" [donations]="sharyCard" cardType="sharee" [fundraiser]="fundraiser"></app-support-card>
  </div>
</div>

<ng-template #profilePic>
  <div *ngIf="!fundraiser.non_medical">
    <div *ngIf="fundraiser?.media_beneficiary" class="profile-img">
      <img loading="lazy" alt="{{beneficiary?.full_name}}" [attr.data-src]="fundraiser?.media_beneficiary?.cdn_path"/>
    </div>
    <i *ngIf="!fundraiser?.media_beneficiary" class="icon-user1"></i>
  </div>
  <div *ngIf="fundraiser?.non_medical" class="non_medical">
    <div *ngIf="fundraiser?.beneficiary?.avtar" class="profile-img">
      <img loading="lazy" alt="{{fundraiser?.beneficiary?.full_name}}" [attr.data-src]="fundraiser?.beneficiary?.avtar?.cdn_path"/>
    </div>
    <i *ngIf="!fundraiser?.beneficiary?.avtar" class="icon-user1"></i>
  </div>
</ng-template>

<div *ngIf="showPopover" [ngTemplateOutlet]="varifiedTeam"></div>

<!-- varified by team bottom sheet-->
<ng-template #varifiedTeam>
  <div id="popoverelement" class="verified-team">
    <button class="close" (click)="closesheet()" mat-icon-button>
      <i class="material-icons">close</i>
    </button>
    <div class="title">{{'Stories.referAFriend.verifiedKettoHosp' | translatePipe | async}}</div>
    <div class="description">{{'Stories.referAFriend.verificationDescription' | translatePipe | async}}</div>
    <div class="events">
      <div class="timelines">
        <span class="done-icon"><i class="material-icons">done</i></span>
        <span class="dashed-line"></span>
        <div class="event-details">
          <div *ngIf="fundraiser?.msw_date?.info_1" class="date">{{fundraiser?.msw_date?.info_1  | dayjs:'format':'Do MMM YYYY'}}</div>
          <div class="event">Ketto’s representative met the patient at the hospital, along with the hospital staff</div>
        </div>
      </div>
      <div class="timelines">
        <span class="done-icon"><i class="material-icons">done</i></span>
        <!-- <span class="dashed-line"></span> -->
        <div class="event-details">
          <div *ngIf="fundraiser?.msw_date?.info_1" class="date">{{fundraiser?.msw_date?.info_1 | dayjs:'format':'Do MMM YYYY'}}</div>
          <div class="event">Story was published after receiving patient’s documents</div>
        </div>
      </div>
      <!-- <div class="timelines">
        <span class="done-icon"><i class="material-icons">done</i></span>
        <div class="event-details">
          <div *ngIf="fundraiser?.action_at" class="date">{{fundraiser?.action_at | dayjs:'format':'Do MMM YYYY'}}</div>
          <div class="event">Story was published after receiving patient’s medical and personal verification documents</div>
        </div>
      </div> -->
    </div>
  </div>
</ng-template>
